import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

// Notification Interface
export interface Notification {
  id: string;
  type: string;
  title: string;
  message: string;
  patient_id: string;
  patient_pid?: string;
  patient_name: string;
  data: any;
  user_id: string;
  organization_id: string;
  is_read: boolean;
  created_at: string;
  read_at: string | null;
}

// Notification Response Interface
export interface NotificationResponse {
  notifications: Notification[];
  total: number;
  page: number;
  limit: number;
  unread_count: number;
  has_next: boolean;
  has_prev: boolean;
}

// Notification Stats Interface
export interface NotificationStats {
  unread_count: number;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationsApiService {
  private apiUrl = `${environment.apiUrl}/notifications`;

  constructor(private http: HttpClient) {}

  /**
   * Get notifications with pagination
   */
  getNotifications(page: number = 1, limit: number = 20): Observable<NotificationResponse> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString());

    return this.http.get<NotificationResponse>(this.apiUrl, { params });
  }

  /**
   * Get notification statistics (unread count)
   */
  getNotificationStats(): Observable<NotificationStats> {
    return this.http.get<NotificationStats>(`${this.apiUrl}/stats`);
  }

  /**
   * Mark a notification as read
   */
  markAsRead(notificationId: string): Observable<any> {
    return this.http.patch(`${this.apiUrl}/${notificationId}/read`, {});
  }

  /**
   * Mark all notifications as read
   */
  markAllAsRead(): Observable<any> {
    return this.http.patch(`${this.apiUrl}/read-all`, {});
  }

  /**
   * Delete a notification
   */
  deleteNotification(notificationId: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${notificationId}`);
  }
}
